export default __webpack_public_path__ + "static/media/insta.56e1f1b2.svg";